const userDetails = () => {
  try {
    if (global.window.localStorage) {
      const userDetailsStr = global.window.localStorage.user_details;
      return JSON.parse(userDetailsStr);
    }
  } catch (e) {
    // ignore JSON.parse error
  }

  return {};
};

const jwtHelpers = {
  getUserDetails() {
    return userDetails() || null;
  },

  getAuthToken() {
    return userDetails().token || null;
  },

  getOktaId() {
    return userDetails().id || null;
  },
};

export default jwtHelpers;
